import _ from 'lodash';

/**
 * Convert a value to a ux friendly display name
 * @param {string} value - Value to convert
 * @returns converted value to ux friendly display name
 */
export const convertToDisplayName = (value: string | number) => {
    value = String(value);

    // if the string is an email return
    const isEmail = value.match(
        /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/g
    );
    if (isEmail) return value;

    // correctly match the last index if available on the array field (ie field.1.subfield = 1)
    const index = value
        .match(/(\.(\d)\.)/g)
        ?.slice(-1)?.[0]
        ?.replaceAll('.', '');

    const enumeration =
        !index || Number(index) === 0 ? '' : ` ${Number(index) + 1}`;

    // if its a deeply nested field name, we need to correctly reach it
    const deepestField = value.match(/(^[^.]+$)|((?!\.)[^.]+)$/g);

    return `${String(deepestField)
        // replace all snake-case and kebab-case
        .replace(/_|-/g, ' ')
        // replace all camel case and pascal case
        .replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`)
        .split(' ')
        .map((word) => _.capitalize(word))
        .join(' ')}${enumeration}`;
};
